(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/nan-excluded.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/nan-excluded.js');
'use strict';

const NanExcluded = _ref => {
  let exlusions = _ref.exlusions,
    url = _ref.url;
  return React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Nationellt avst\xE4ngd"), React.createElement("p", null, "Du har en aktiv spelpaus p\xE5", ' ', React.createElement("a", {
    className: "fc-sport-75",
    href: url
  }, "spelpaus.se"), ' ', "och \xE4r d\xE4rmed avst\xE4ngd f\xF6r alla spel hos samtliga spelbolag som \xE4r registrerade hos Spelinspektionen."), exlusions && React.createElement("span", null, "Denna helt\xE4ckande spelpaus t\xE4cker \xE4ven eventuella spelpauser du tagit f\xF6r specifika spel hos Svenska Spel Sport & Casino enligt nedan."));
};
svs.selfExclusion.components.NanExcluded = NanExcluded;

 })(window);